module.exports = __webpack_public_path__ + "static/media/celebrity_category.5cf447e6.jpg";